import React, { useCallback, useRef } from 'react'
import { Box, BoxProps, Text, TextField } from '@ui'

const validateValue = (value: string) => {
    const parsed = Number(value)
    return isNaN(parsed) ? '0' : Math.min(Math.max(Math.round(parsed), 0), 100).toString()
}

const percent = (
    <Text color="peach" fontWeight="medium">
        %
    </Text>
)

export const PercentInputRadio = (props: {
    color: BoxProps['color']
    onChange: (value: number) => void
    compact?: boolean
    value?: bigint
}) => {
    const textRef = useRef<HTMLInputElement>(null)
    const onSelect = useCallback(() => {
        textRef.current?.focus()
    }, [])

    const onChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const validatedValue = validateValue(e.target.value)
            props.onChange(Number(validatedValue))
        },
        [props],
    )

    // Always use controlled mode with a default value of empty string
    const displayValue = props.value !== undefined ? Number(props.value).toString() : ''

    return (
        <Box horizontal color="peach" onClick={onSelect}>
            <TextField
                grow
                style={{ minWidth: '55px' }}
                min={0}
                max={100}
                step={1}
                ref={textRef}
                type="number"
                rounded="md"
                height="x4"
                background="level2"
                placeholder="Custom"
                before={percent}
                color="peach"
                value={displayValue}
                onChange={onChange}
            />
        </Box>
    )
}
